import "@/App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/context/LangContext";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { SiteMediaProvider } from "@/context/SiteMediaContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Reviews from "@/pages/Reviews";
import Contact from "@/pages/Contact";
import AuthPage from "@/pages/AuthPage";
import Account from "@/pages/Account";
import Reseller from "@/pages/Reseller";
import SkinTest from "@/pages/SkinTest";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import WhatsAppButton from "@/components/WhatsAppButton";
import AnnouncementBar from "@/components/AnnouncementBar";
import GiftPopup from "@/components/GiftPopup";
import Admin from "@/pages/Admin";
import GiftCards from "@/pages/GiftCards";
import PasswordReset from "@/pages/PasswordReset";
import { ShippingProvider } from "@/context/ShippingContext";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <LangProvider>
        <AuthProvider>
          <SiteMediaProvider>
           <ShippingProvider>
           <CartProvider>
            <BrowserRouter>
              <ScrollToTop />
              <AnnouncementBar />
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/product/:slug" element={<ProductDetail />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/reviews" element={<Reviews />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/login" element={<AuthPage mode="login" />} />
                  <Route path="/register" element={<AuthPage mode="register" />} />
                  <Route path="/forgot-password" element={<PasswordReset mode="forgot" />} />
                  <Route path="/reset-password" element={<PasswordReset mode="reset" />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/reseller" element={<Reseller />} />
                  <Route path="/skin-test" element={<SkinTest />} />
                  <Route path="/gift-card" element={<GiftCards />} />
                  <Route path="/payment/success" element={<PaymentSuccess />} />
                  <Route path="/payment/cancel" element={<PaymentCancel />} />
                </Routes>
              </main>
              <Footer />
              <WhatsAppButton />
              <GiftPopup />
              <Toaster position="top-center" />
            </BrowserRouter>
           </CartProvider>
           </ShippingProvider>
          </SiteMediaProvider>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
